import { RestHandler, MockedRequest, DefaultRequestBody, rest } from 'msw';
import { DB } from '../db';

const routes: RestHandler<MockedRequest<DefaultRequestBody>>[] = [];

routes.push(
    rest.get('/profile', (req, res, ctx) => {
        const user = DB.GetUser('7ea16ac1-99cf-478a-80b1-7f25458522e5');
        return res(ctx.delay(), ctx.status(200), ctx.json({ user }));
    })
);

export { routes };
